import { useCallback, useEffect, useRef, useState } from 'react';
import debounce from 'lodash/debounce'; // Import the debounce function
import Skeleton from '../../Utilities/Skeleton';
import PatientList from './PatientList';
import { post } from '../Auths/AuthToken';
import Pagination from '../../Utilities/Pagination';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { format, subDays } from 'date-fns';
import setUiMessage from '../../Utilities/Tostify';
import { useSelector } from 'react-redux';
import DatePickerCalander from '../../Utilities/DatePickerCalander';

function Patient() {
  const { user } = useSelector((store) => store.auth);
  const { appSearchPrams } = useSelector((store) => store.appointment);
  const [allData, setAllData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);

  const [serchInput, setSerchInput] = useState({
    nameSerch: '',
    lastVisitSerch: '',
    nextVisitSerch: '',
    payorSerch: '',
    resourceId: appSearchPrams.allProviders || '',
    offSet: 0,
    limit: 0,
    startDate: subDays(new Date(), 90),
    endDate: new Date(),
    filterValue: '90D',
    // stDatePickerIsOpen: false,
    // ndDatePickerIsOpen: false,
    isDateRange: false,
  });

  const handlePageChange = useCallback((data) => {
    setSerchInput((prevInput) => ({
      ...prevInput,
      offSet: data[0],
      limit: data[1],
    }));
  }, []);

  const [reload, setReload] = useState(false);
  const debouncedFetchData = useRef(
    debounce(async (searchParams) => {
      try {
        let filterVal;
        if (
          searchParams?.filterValue === 'ALL' ||
          searchParams?.filterValue === '90D' ||
          searchParams?.filterValue === '60D' ||
          searchParams?.filterValue === '30D'
        ) {
          filterVal = searchParams?.filterValue;
        } else {
          if (searchParams?.startDate && searchParams?.endDate)
            filterVal = `${format(
              searchParams.startDate,
              'yyyy-MM-dd'
            )}|${format(searchParams.endDate, 'yyyy-MM-dd')}`;
        }

        if (filterVal) {
          setIsLoading(true);
          const response = await post('api/patient/patient/getAllPatientList', {
            nameSerch: searchParams?.nameSerch,
            lastVisitSerch: searchParams?.lastVisitSerch, //mob or email
            nextVisitSerch: searchParams?.nextVisitSerch,
            payorSerch: searchParams?.payorSerch,
            resourceId: searchParams?.resourceId,
            offSet: searchParams?.offSet,
            limit: searchParams?.limit,
            staffUserId: user?.id,
            weekFilterValue: filterVal, //ALL, 30D, 60D, 90D, 2024-01-01|2024-12-09
            patientListStatus: 'ALL', //ALL->ALL, 0->Inactive,1->Active,2->Deceased
            patientListLocation: 'ALL', //ALL->ALL,..
            patientListType: 'ALL', //ALL->ALL,..
          });

          if (response?.status === 200) {
            setAllData(response?.data);
            setIsLoading(false);
            setTotalRecord(response?.data.total || 0);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    }, 700)
  ).current;

  useEffect(() => {
    debouncedFetchData(serchInput);
    // Cleanup the debounced function on unmount
    return () => {
      debouncedFetchData.cancel();
    };
  }, [serchInput, debouncedFetchData, reload]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSerchInput((prevInput) => ({
      ...prevInput,
      [name]: value,
      offSet: 0,
    }));
  };

  return (
    <>
      <div
        style={{
          display: '',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '5px 12px',
        }}
      >
        <div className="bnc-mn-hdr">
          <div className="bill-dt-main-con">
            <div className="bill-days-blk">
              <span className="intake-head-inpt-main">
                <span className="intake-head-hedding">Duration:</span>
                <span className="intake-head-inpt-sec">
                  <input
                    type="radio"
                    name="radio2"
                    onChange={() =>
                      setSerchInput((prev) => ({
                        ...prev,
                        filterValue: 'ALL',
                        isDateRange: false,
                        startDate: null,
                        endDate: null,
                        offSet: 0,
                      }))
                    }
                    checked={serchInput?.filterValue === 'ALL' ? true : false}
                  />
                  <span className="">All</span>
                </span>

                <span className="intake-head-inpt-sec">
                  <input
                    type="radio"
                    name="radio2"
                    onChange={() =>
                      setSerchInput((prev) => ({
                        ...prev,
                        filterValue: '90D',
                        isDateRange: false,
                        startDate: subDays(new Date(), 90),
                        endDate: new Date(),
                        offSet: 0,
                      }))
                    }
                    checked={serchInput?.filterValue === '90D' ? true : false}
                  />
                  <span className="">90 days</span>
                </span>

                <span className="intake-head-inpt-sec">
                  <input
                    type="radio"
                    name="radio2"
                    onChange={() =>
                      setSerchInput((prev) => ({
                        ...prev,
                        filterValue: '60D',
                        isDateRange: false,
                        startDate: subDays(new Date(), 60),
                        endDate: new Date(),
                        offSet: 0,
                      }))
                    }
                    checked={serchInput?.filterValue === '60D' ? true : false}
                  />
                  <span className="">60 days</span>
                </span>

                <span className="intake-head-inpt-sec">
                  <input
                    type="radio"
                    name="radio2"
                    onChange={() =>
                      setSerchInput((prev) => ({
                        ...prev,
                        filterValue: '30D',
                        isDateRange: false,
                        startDate: subDays(new Date(), 30),
                        endDate: new Date(),
                        offSet: 0,
                      }))
                    }
                    checked={serchInput?.filterValue === '30D' ? true : false}
                  />
                  <span className="">30 days</span>
                </span>

                <div className="intake-serch-calander-sec">
                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onClick={() =>
                        setSerchInput((prev) => ({
                          ...prev,
                          filterValue: 'D',
                          isDateRange: true,
                          startDate: null,
                          endDate: null,
                          offSet: 0,
                        }))
                      }
                    />
                  </span>
                  <span className="intake-serch-calander">
                    <DatePickerCalander
                      selectedDate={serchInput.startDate}
                      setSelectedDate={(date) =>
                        setSerchInput((prev) => ({ ...prev, startDate: date }))
                      }
                      className="add-task-date-picker"
                      style={{
                        width: '75px',
                      }}
                      dateFormat={DEFAULT_DATE_FORMATE}
                      maxDate={serchInput?.endDate}
                      editFlag={!serchInput.isDateRange}
                    />
                  </span>
                  <span className="date-sep-blu-hdr">-</span>
                  <span className="intake-serch-calander">
                    <DatePickerCalander
                      selectedDate={serchInput.endDate}
                      setSelectedDate={(date) =>
                        setSerchInput((prev) => ({ ...prev, endDate: date }))
                      }
                      className="add-task-date-picker"
                      style={{
                        width: '75px',
                      }}
                      dateFormat={DEFAULT_DATE_FORMATE}
                      minDate={serchInput?.startDate}
                      maxDate={new Date()}
                      editFlag={!serchInput.isDateRange}
                    />
                  </span>
                </div>
              </span>
            </div>
            <div className="flex-sec fontsize14 justyfy-between item-center gap10">
              <span>Select Resource</span>
              <span>
                <select
                  name="resourceId"
                  id="resourceId"
                  onChange={handleInputChange}
                  value={serchInput?.resourceId}
                >
                  <option value="">All</option>
                  {allData?.allResource &&
                    allData?.allResource.map((item, i) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.resName}
                      </option>
                    ))}
                </select>
              </span>
            </div>
          </div>
        </div>

        <Pagination
          totalRecord={totalRecord}
          onPageChange={handlePageChange}
          offset={serchInput?.offSet}
          rowPerPage={50}
        />
      </div>
      <div id="patientList" className="patient-list-Section">
        <div id="" className="patient-list-hdr">
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-1">
            <span className="bold">Name</span>
            <input
              type="search"
              id="nameInput"
              name="nameSerch"
              className="main-search"
              placeholder="Search Patient..."
              value={serchInput?.nameSerch}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-3 hide">
            <input
              type="search"
              id="dobInput"
              name="dobSerch"
              className="main-search"
              placeholder="Search DoB..."
            />
          </div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-6">
            <span className="bold">Last Visit</span>
            <input
              type="search"
              id="lastVisitInput"
              name="lastVisitSerch"
              className="main-search"
              placeholder="Search visit..."
              value={serchInput?.lastVisitSerch}
              onChange={handleInputChange}
            />
          </div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-7">
            <span className="bold">Next Appt.</span>
            <input
              type="search"
              id="nextVisitInput"
              name="nextVisitSerch"
              className="main-search"
              placeholder="Search Appt...."
              value={serchInput?.nextVisitSerch}
              onChange={handleInputChange}
            />
          </div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-8">Appt</div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-9">
            <span className="bold">Payor</span>
            <input
              type="search"
              id="payorInput"
              name="payorSerch"
              className="main-search"
              placeholder="Search Payor..."
              value={serchInput?.payorSerch}
              onChange={handleInputChange}
            />
          </div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-10">Action</div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-4">Address</div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-5">Contact</div>
          <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-11">Status</div>
        </div>
        <div id="" className="patient-list-bdy">
          {isLoading ? (
            <Skeleton />
          ) : allData?.patients && allData?.patients.length > 0 ? (
            allData?.patients.map((item, i) => {
              const altClas = i % 2 !== 0 ? 'alt-rw' : '';
              return (
                <PatientList
                  key={i}
                  item={item}
                  altClas={altClas}
                  handleReload={() => setReload(!reload)}
                />
              );
            })
          ) : (
            'No Result Found'
          )}
        </div>
      </div>
    </>
  );
}

export default Patient;
